import { createContext, useMemo, useState } from "react";

import { Direction, Ordering, createOrdering } from "~/utils/ordering";

export enum Field {
  USER_NAME = "user_name",
  COMPANY_NAME = "user__company__name",
  NOTIFICATIONS_ENABLED = "notifications_enabled",
  LAST_LOGIN = "last_login",
  USER_GROUP_NAME = "user_group__name",
  ROLE_NAME = "user_group__role__name",
}

export interface OrderingContextValue {
  ordering: Ordering<Field>;
  setOrdering: (ordering: Ordering<Field>) => void;
  serializeOrdering: (ordering: Ordering<Field>) => string;
}

export const useOrderingContext = (): OrderingContextValue => {
  const [ordering, setOrdering] = useState(createOrdering(Field.USER_NAME));

  return useMemo(() => {
    const serializeOrdering = (orderObj: Ordering<Field>): string => {
      // Serialize ordering into syntax DRF wants
      if (orderObj.field === "user_name") {
        return orderObj.direction === Direction.ASC
          ? "user__last_name,user__first_name"
          : "-user__last_name,-user__first_name";
      }

      return orderObj.direction === Direction.ASC
        ? orderObj.field
        : `-${orderObj.field}`;
    };
    return { ordering, setOrdering, serializeOrdering };
  }, [ordering, setOrdering]);
};

const OrderingContext = createContext<OrderingContextValue>(null as any);

export default OrderingContext;
